import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    host: { class: 'styled-modal' }
})
export class ConfirmModalComponent {
    @Input() title: string = ''
    @Input() text: string = ''
    @Input() warn: boolean = false

    constructor(private dialogRef: NgbActiveModal) {}

    confirm(): void {
        this.dialogRef.close(true)
    }

    decline(): void {
        this.dialogRef.close(false)
    }

    close(): void {
        this.dialogRef.close(null)
    }
}
